import * as Prismic from '@prismicio/client'
import processEnvPublic from 'unlikely-env/public'

const endpoint = Prismic.getRepositoryEndpoint(
  processEnvPublic('NEXT_PUBLIC_PRISMIC_REPO_NAME'),
)

const prismic = Prismic.createClient(endpoint)

export function hasDataIntoDocument(document) {
  const data = document?.data ?? {}
  return Object.keys(data)?.length > 0 ?? false
}

export { prismic }
export default Prismic
